import {createContext, useEffect, useState} from "react"
import ApiPlannings from "../services/planning";
import {getCurrentCNPJ} from "../services/utils";
import {getCompaniesCache, setCompaniesCache} from "../services/companiesCache";

const companiesData = getCompaniesCache()
export const AppContext = createContext(companiesData)

export const AppProvider = ({ children, account }) => {
  const [tutorialTotalSteps] = useState(17)
  const [companies, setCompanies] = useState(companiesData)
  const [reachedTheLimitOfPlanning, setreachedTheLimitOfPlanning] = useState(false)

  const toggleCompanies = (cnpj) => {
    const updatedData = companies.map((el) => ({
      ...el,
      isActive: el.cnpj === cnpj,
    }))

    setCompaniesCache(updatedData)
    setCompanies(updatedData)
  }
  const updateNumberOfActivePlanning = (fnFinalized = null) => {
    const company = getCurrentCNPJ(companies) || null
    ApiPlannings().countActivePlannings(company)
      .then(({data}) => {
        setreachedTheLimitOfPlanning(data.count >= 120)
      })
      .finally(() => {
        if (fnFinalized) fnFinalized()
      })
  }

  useEffect(() => {
    if (!!account) updateNumberOfActivePlanning()

    // eslint-disable-next-line
  }, [account])

  return (
    <AppContext.Provider
      value={{
        companies,
        setCompanies,
        toggleCompanies,
        tutorialTotalSteps,
        reachedTheLimitOfPlanning,
        updateNumberOfActivePlanning,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}
